import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./RelatedPosts.module.css";

/**
 * Image-first related row for the single post. The still keeps its
 * own aspect; category and title sit on a glass caption. No excerpt,
 * date, author, or read-more — those stay on the /blog index cards.
 */
const RelatedPosts = ({ posts = [], langPrefix = "" }) => {
  const { t } = useTranslation("blog");

  if (!posts.length) return null;

  return (
    <section className={styles.section} aria-labelledby="related-posts-heading">
      <div className={styles.inner}>
        <div>
          <h2 id="related-posts-heading" className={styles.heading}>
            {t("relatedPosts")}
          </h2>
        </div>

        <div className={styles.grid}>
          {posts.map((post, index) => (
            <div key={post.id}>
              <Link
                to={`${langPrefix}/blog/${post.slug}`}
                className={styles.tile}
              >
                <img
                  src={post.featuredImage}
                  alt=""
                  className={styles.image}
                  loading="lazy"
                />
                <span className={styles.caption}>
                  <span className={styles.copy}>
                    <span className={styles.category}>{post.category}</span>
                    <span className={styles.title}>{post.title}</span>
                  </span>
                  <svg
                    className={styles.arrow}
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M5 12h14" />
                    <path d="M13 6l6 6-6 6" />
                  </svg>
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedPosts;
